    <!-- =========================================================================================
    File Name: Settings.vue
    Description: Setting page
========================================================================================== -->
<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? $t('ChangeInformation') : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <settings-general  />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? $t('ChangePassword') : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <settings-change-password />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import SettingsGeneral from "./SettingsGeneral.vue"
import SettingsChangePassword from "./SettingsChangePassword.vue"

import moduleAdmin from "@/store/admin/moduleAdmin.js"

export default {
  components: {
    SettingsGeneral,
    SettingsChangePassword
  },
  data() {
    return {

    }
  },
  created() {
    if (!moduleAdmin.isRegistered) {
      this.$store.registerModule('dataAdmin', moduleAdmin)
      moduleAdmin.isRegistered = true
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    },
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
